export default {
  updateModelsZgi(state, data) {
    state.modelsZgi = data;
  },

  updateMaterialsZgi(state, data) {
    state.materialsZgi = data;
  },

  updateModelsCut(state, data) {
    state.modelsCut = data;
  },

  updateSetList(state, data) {
    state.setList = data;
  },

  updateIsDisabledAddToCart(state, val) {
    state.isDisabledAddToCart = val;
  },

  updateMaterialsCut(state, data) {
    state.materialsCut = data;
  },

  updateModelsOpt(state, data) {
    state.modelsOpt = data;
  },

  updateMaterialsOpt(state, data) {
    state.materialsOpt = data;
  },

  updateConfigCut(state, data) {
    state.configCut = data;
  },

  orderEditUpdate(state, data) {
    state.orderEdit = data;
  },

  paymentUpdate(state, data) {
    state.payment = data;
  },

  updateZgiTender(state, val) {
    state.zgiTender = val;
  },

  updateCutTender(state, val) {
    state.cutTender = val;
  },

  updateRelatedProductMaterial(state, payload = null) {
    state.relatedProduct.material = payload;
  },

  updateRelatedProductModel(state, payload = null) {
    state.relatedProduct.model = payload;
  },

  updateRelatedProductCount(state, payload = 1) {
    state.relatedProduct.count = payload;
  },

  updateRelatedProductCalculation(state, payload = null) {
    state.relatedProduct.calculation = payload;
  },

  updateRelatedMaterials(state, { data, key }) {
    state.relatedMaterials[key] = data;
  },

  updateOptionsList(state, data) {
    if (data) {
      data.forEach(item => {
        if (item.type === 'V' && item.is_required === 1 && !item.error_message) {
          item.option_default = 0;
        }

        if (item.field_type === 'T') {
          item.calculate = false;
        }
      });
    }

    state.optionsList = JSON.parse(JSON.stringify(data));
  },

  updateOptionsListCalculate(state) {
    state.optionsList.forEach(el => {
      if (el.calculate) {
        el.calculate = false;
      }
    });
  },

  updateOptionItem(state, { name, code_1c, value, calculate }) {
    const index = state.optionsList.findIndex(el =>
      code_1c ? el.code_1c === code_1c : el.name === name,
    );

    if (index !== -1) {
      if (calculate !== undefined) {
        state.optionsList[index].calculate = calculate;
      }

      state.optionsList[index].option_default = value;
    }
  },

  updateCopyOrder(state, data) {
    state.orderCopy.path = data.path;
    state.orderCopy.data = data.data;
  },

  updatePrices(state, val) {
    state.prices = val;
  },
};
